import { combineReducers } from 'redux';

import global from './global/globalReducer';
import auth from './auth/authReducer';
import profile from './profile/profileReducer';
import resources from './resources/resourcesReducer';
import products from './products/productsReducer';
import school from './school/schoolReducer';

/**
 * ## CombineReducers
 *
 * the rootReducer will call each and every reducer with the state and action
 * EVERY TIME there is a basic action
 */
const rootReducer = combineReducers({
    global,
    auth,
    profile,
    resources,
    products,
    school
});

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/core/reducers.js
 **/